export enum AttributionModel {
  LastTouch = "last_touch",
  Linear = "linear",
  Direct = "direct",
}
